// extracted by mini-css-extract-plugin
export default {"musicimages":"Home_musicimages__rirpF","pagefooter":"Home_pagefooter__RS8lC","pagewrapper":"Home_pagewrapper__BUIhD"};